  <template>
  <div class="page">
    <header></header>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getUseList"
      >
        <div class="item-list" v-for="(item, index) in useList" :key="index">
          <div class="item"><span>仪器编号：</span><span>{{item.deviceNo}}</span></div>
          <div class="item"><span>消费订单号：</span><span>{{item.consumeNo}}</span></div>
          <div class="item"><span>使用时间：</span><span>{{item.useTime}}</span></div>
          <div class="item"><span>充值时间：</span><span>{{item.createTime}}</span></div>
          <div class="item"><span>使用开始时间：</span><span>{{item.useStartTime}}</span></div>
          <div class="item"><span>使用结束时间：</span><span>{{item.useEndTime}}</span></div>
        </div>
        <!-- <div v-for="(item, index) in useList" :key="index">
          仪器编号{{ item.deviceNo }} 
          消费订单号{{ item.consumeNo }} 
          使用时间{{ item.useTime }}
          充值时间{{ item.createTime }} 
          使用开始时间{{ item.useSatrTime }}
          使用结束时间{{ item.useEndTime }}
        </div> -->
      </van-list>
    </div>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data() {
    return {
      useList: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 200,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getUseList() {
      if(!this.finished){
      this.$get(`${API.carduseInfo}?icCard=${sessionStorage.getItem("card")}&pageSize=${this.pageSize}&pageNum=${this.page}`)
        .then((res) => {
          if (res.code == 200) {
            this.useList = this.useList.concat(res.data.rows);
            if(this.page*this.pageSize < res.data.total){
              this.page ++
            }
            else{
              this.finished = true
              this.loading = true
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
    },
  },
  created() {},
  mounted() {
    // this.getUseList();
  },
};
</script>
<style scoped>
header{
  width: 375px;
  height: 180px;
  background: url(/static/img/bg.png)no-repeat top;
  background-size: 100% 100%;
}
.content{
  margin-top: -14%;
  position: relative;
  z-index: -1;
  margin-left: 15px;
  margin-right: 15px;
}
.van-list .item-list{
  padding: 65px 15px 20px
}
.van-list .item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: .4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/useinfo.vue